import { Injectable, OnDestroy } from '@angular/core';
import { Reloadable } from '../command/command.service';

export interface RefetchEvent {
  entityType: string;
  entityId?: string;
}

interface RegisteredReloadable {
  reloadable: Reloadable;
  entityType: string;
  entityId?: string;
}

@Injectable({ providedIn: 'root' })
export class RefetchCoordinator implements OnDestroy {

  private registry: RegisteredReloadable[] = [];
  private channel = new BroadcastChannel('refetch-coordinator');

  constructor() {
    this.channel.onmessage = (event) => this.handleEvent(event.data);
  }

  register(reloadable: Reloadable, entityType: string, entityId?: string): () => void {
    const entry: RegisteredReloadable = { reloadable, entityType, entityId };
    this.registry.push(entry);

    return () => {
      const index = this.registry.indexOf(entry);
      if (index > -1) this.registry.splice(index, 1);
    };
  }

  emit(event: RefetchEvent): void {
    this.handleEvent(event);
    this.channel.postMessage(event);
  }

  private handleEvent(event: RefetchEvent): void {
    this.registry.forEach(({ reloadable, entityType, entityId }) => {
      if (entityType !== event.entityType) {
        return;
      }

      if (!entityId) {
        reloadable.reload();
        return;
      }

      if (event.entityId && entityId === event.entityId) {
        reloadable.reload();
      }
    });
  }

  ngOnDestroy(): void {
    this.channel.close();
  }
}
